import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import { setUnauthorizedHandler } from '../services/api';

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/DashboardView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/appointments',
    name: 'Appointments',
    component: () => import('../views/DashboardView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/week',
    name: 'Week',
    component: () => import('../views/WeekView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/month',
    name: 'Month',
    component: () => import('../views/MonthView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/appointments/:id',
    name: 'AppointmentDetail',
    component: () => import('../views/AppointmentDetailView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/clients',
    name: 'Clients',
    component: () => import('../views/ClientsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/clients/:id/history',
    name: 'ClientHistory',
    component: () => import('../views/ClientHistoryView.vue'),
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  const auth = useAuthStore();

  // Se usuário ainda não foi verificado, tentar restaurar sessão
  if (auth.user === null && !auth.loading && to.meta.requiresAuth !== false) {
    await auth.checkAuth();
  }

  // Rota protegida sem autenticação → redireciona para login
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return next({ name: 'Login' });
  }

  // Usuário autenticado tentando acessar login → redireciona para dashboard
  if (to.name === 'Login' && auth.isAuthenticated) {
    return next({ name: 'Dashboard' });
  }

  next();
});

// Ao receber 401 em qualquer chamada de API, limpar sessão e ir para login
setUnauthorizedHandler((endpoint) => {
  // Ignorar 401 da própria rota de /auth/me (é verificação intencional)
  if (endpoint && endpoint.startsWith('/auth/me')) return;

  const auth = useAuthStore();
  auth.user = null;
  auth.isAuthenticated = false;

  // Evitar redirect se já estiver em /login
  if (router.currentRoute.value.name !== 'Login') {
    router.push({ name: 'Login' });
  }
});

export default router;
